/**
 * /frontend/src/features/analytics/components/charts/DualAxisLineChart.js
 */

import React from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Dual-axis line chart (two different y-scales).
 * @param {{data:any[],xKey:string,leftKey:string,rightKey:string,leftLabel:string,rightLabel:string,height?:number}} props
 * @returns {JSX.Element}
 */
const DualAxisLineChart = ({ data, xKey, leftKey, rightKey, leftLabel, rightLabel, height }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <LineChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis yAxisId="left" stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis yAxisId="right" orientation="right" stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <Tooltip />
        <Line yAxisId="left" type="monotone" dataKey={leftKey} name={leftLabel} stroke={CHART_COLORS.accent} strokeWidth={2} dot={false} />
        <Line yAxisId="right" type="monotone" dataKey={rightKey} name={rightLabel} stroke={CHART_COLORS.warning} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default DualAxisLineChart;
